<template>
    <svg
        v-if="COLOR_NAMESPACES.find(namespace => computedCode?.includes(namespace)) || set === 'svg' || opts.preferSVG"
        :class="[
            'icon', 'ds-icon',
            `icon-${computedCode.replaceAll('/', '-') }`,
            { debug, [`size-${size}`]: !customSize, }
        ]"
        :style="{ width: customSize, height: customSize }"
        :aria-label="alt || `${$t('dsIcon.icon')} ${computedCode.split('/')[1]}`"
    >
        <use v-if="isDev" :href="`/${`__${computedCode.split('/')[0]}` || '__spritemap'}#sprite-${computedCode}`" />
        <use v-else :href="`${origin}/_nuxt/${computedCode.split('/')[0]}.${ts}.svg#sprite-${computedCode}`" />
    </svg>
    <i
        v-else
        :class="[
            'icon', 'ds-icon',
            `icon-${computedCode.split('/')[1]}`,
            `set-${set}`,
            `style-${fontStyle}`,
            { debug, [`size-${size}`]: !customSize, },
        ]"
        :style="{ fontSize: customSize }"
    />
</template>
<script setup>
import { computed, inject, useRuntimeConfig, useRequestURL } from '#imports';

const props = defineProps({
    alt: {
        type: String,
        default: '',
    },
    code: {
        type: [String, null],
        default: '',
    },
    size: {
        type: String,
        default: 'm',
    },
    set: {
        type: String,
        default: 'default',
    },
});

const { origin } = useRequestURL();

const defaultOptions = { debug: false, preferSVG: false, defaultNamespace: 'default-line' };
const injection = inject('dsIconConfig', defaultOptions);
const opts = computed(() => ({ ...defaultOptions, ...injection.value }));

const computedCode = computed(() => props.code.split('/').length > 1 ? props.code : `${opts.value?.defaultNamespace}/${props.code}`);
const customSize = computed(() => (props.size.match(/[\d\\.]+/) || {}).input);
const fontStyle = computed(() => computedCode.value.split('/').length > 1 ? computedCode.value.split('/')[0].split('-').at(-1) : opts.value?.defaultNamespace);
const isDev = process.env.NODE_ENV === 'development';
const debug = computed(() => isDev && opts.value?.debug);
const ts = computed(() => useRuntimeConfig().public.svgSpritemapTimestamp);

const COLOR_NAMESPACES = ['flags/', 'logos/'];
</script>

<style scoped>
.icon {
  display: inline-flex;
}

i.size-xxs {
  font-size: 0.25rem;
}
i.size-xs {
  font-size: 0.5rem;
}
i.size-s {
  font-size: 0.75rem;
}
i.size-m {
  font-size: 1rem;
}
i.size-l {
  font-size: 1.25rem;
}
i.size-xl {
  font-size: 1.5rem;
}
i.size-xxl {
  font-size: 1.75rem;
}
i.size-xxxl {
  font-size: 2rem;
}
i.size-xxxxl {
  font-size: 2.25rem;
}

svg {
  place-items: center;
  line-height: 1;
  aspect-ratio: 1;
  overflow: visible;
  max-width: unset;
}
svg.size-xxs {
  width: 0.25rem;
}
svg.size-xs {
  width: 0.5rem;
}
svg.size-s {
  width: 0.75rem;
}
svg.size-m {
  width: 1rem;
}
svg.size-l {
  width: 1.25rem;
}
svg.size-xl {
  width: 1.5rem;
}
svg.size-xxl {
  width: 1.75rem;
}
svg.size-xxxl {
  width: 2rem;
}
svg.size-xxxxl {
  width: 2.25rem;
}
svg:not([class*=icon-flags-]) > use,
svg:not([class*=icon-flags-]) svg {
  fill: currentcolor;
}

.debug {
  position: relative;
  outline: 2px solid red;
  aspect-ratio: 1;
  background-color: pink;
}
</style>
